/** How far along a student's career thinking is, as the consideration score reports it. */
export const CONSIDERATION_RISK_STATUS = {
  Low: 'low',
  Medium: 'medium',
  High: 'high',
} as const;

export type ConsiderationRiskStatus = typeof CONSIDERATION_RISK_STATUS[keyof typeof CONSIDERATION_RISK_STATUS];
